import DesignTokens from '@tableau/design-tokens';
import { cssRule } from 'typestyle';

import { applyColor }from '~src/style/ColorService';

cssRule('.tb-tooltip', {
    position: 'absolute',
    left: 0,
    top: 0,
    border: '1px solid ' + applyColor(DesignTokens.color.elevation.border.default.default, '#b2b2b2'),
    backgroundColor: applyColor(DesignTokens.color.elevation.surface.default.subtle, '#F5F5F5'),
    padding: '6px',
    whiteSpace: 'nowrap',
    zIndex: 1,
});

